import React, { ReactNode } from 'react';

import { FormattedMessage } from 'react-intl';

export const formatMessageOverflow = (cutoff: number, eventTitle: string): ReactNode =>
    eventTitle.length > cutoff ? (
        <FormattedMessage
            description="A message that is too long, so we shorten it with an ellipse (...)"
            defaultMessage="{message}..."
            values={{
                message: eventTitle.slice(0, cutoff),
            }}
        />
    ) : (
        eventTitle
    );
